import React, { useEffect } from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import AresLogo from './../../../assets/img/ares-logo.png'
import SynapseLogo from './../../../assets/img/synapse-logo.png'
import DownloadPlayStore from './../../../assets/img/app/googleplay.png'
import DownloadAppStore from './../../../assets/img/app/appstore.svg'
import CreditCardIcons from './../../../assets/img/footer/credit-card-icons.png'


import { FaFacebookSquare, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'

import './index.css'

export default function Footer() {

    useEffect(() => {
        console.log('footer page')
    }, [])

    return (
        <section className="Footer">
            <div className="footer-content">
                <Row>
                    <Col className="about-ares" md={4}>
                        <img src={AresLogo} alt="Ares logo" width="200" />

                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries
                             </p>
                    </Col>

                    <Col className="payment center-horizontal center-vertical" md={5}>
                        <img src={CreditCardIcons} className="img-fluid"  alt="Credit card"/>
                    </Col>

                    <Col className="footer-download-app" md={3}>
                        <div className="stores">
                        <h3>Baixe o aplicativo</h3>
                            <img src={DownloadPlayStore} alt="download in play store" width="250" style={{ transform: 'translate(-15px, 0px)' }}/>
                            <img src={DownloadAppStore} alt="download in app store" width="220"/>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="footer-bottom">
                <div className="left">
                    <img src={SynapseLogo} alt="ares logo" width="200" />

                    <div className="enterprise-info">
                        <div className="top">
                            Synapse Brasil soluções em tecnologia LTDA - 12.018.815/0001-87
                        </div>

                        <div className="bottom">
                            SRTVN Centro Empresarial Norte Sala 802-A - Brasilia, Brasília - DF, 70719-903
                        </div>
                    </div>

                </div>

                <div className="right">
                    <div className="social">
                        <a href="#">
                            <FaFacebookSquare />
                        </a>

                        <a href="#">
                            <FaInstagram />
                        </a>

                        <a href="#">
                            <FaLinkedin />
                        </a>

                        <a href="#">
                            <FaTwitter />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}